import React, { useEffect, useState,useRef  } from 'react';
import Table from 'react-bootstrap/Table';
import { useReactToPrint } from 'react-to-print';
import '../style.css';
import {CanvasJSChart} from 'canvasjs-react-charts'

const KplAssetReport = () => { 
    const [apiData, setApiData] = useState([]);
    const chartRef = useRef(null);
    
      useEffect(() => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          try {
            // Send the JSON data to the API
            const response = fetch("http://evantage.ddns.net/react_web/get_assetmaster_count.php?site_cd=MSW", requestOptions)
          .then(response => response.text())
          .then(result => { 
           const dt = JSON.parse(result);
            setApiData(dt);
          })
          }catch(error){
            console.error("error",error);
          }
      }, [])
      
      const handlePrint = useReactToPrint({
        content: () => chartRef.current,
      });
        // Get percentage 
        const totlValue = apiData.Active + apiData.Deactivate;

        const percentageActv = (apiData.Active / totlValue ) * 100;
        const percentageDeact = (apiData.Deactivate / totlValue ) * 100;
        //alert(percentage.toFixed(2));
    const options = {
     
        animationEnabled: true,
        exportFileName: "Kpl Asset Report",
       // exportEnabled: true,
        title:{
            padding: {
                top: 15,
                right: 1,
                bottom: 2,
                left: 2
              },
            text: "Total Asset by Status 2023",
        },
        //width: 320,
        data: [{
            type: "pie",
            startAngle: 75,
            showInLegend: true,
            indexLabelFontSize: 17,
            legendText: "{label}",
            indexLabelFontColor: "#fff",
            toolTipContent: "{label}: <strong>{y}%</strong>",
            indexLabel: "{y}%",
            indexLabelPlacement: "inside",
            dataPoints: [
                { y: percentageActv.toFixed(2), label: "Active",color: '#04AA6D' },
                { y: percentageDeact.toFixed(2), label: "Deactivate" },
            ]
        }]
    }
    

  return (
    
    <>
   
    <div>
    <div className="page-header" style={{ marginTop: "10px", marginBottom:"10px" }}>
        <h3 className="page-title">
            Asset Kpl Report
        </h3>  
    </div>
    <button  className="btn btn-dark btn-sm mt-2 mb-4" onClick={handlePrint}>Print</button>
            <div className="container">
                <div className="row">
                    <div className="col-1">
                    
                    </div>
                    <div className="col-10">
                      <div ref={chartRef} className="bgKplClr">
       
                        <CanvasJSChart options = {options}/> 
                        
                           <Table striped bordered hover size="sm" responsive className="tableKpl mt-5 mb-5">
                            <thead>
                            <tr className="same-col-widths">
                                <th>Asset Status Type</th>
                                <th>Corrective</th>
                                <th>Preventive</th>
                                <th>Year</th>
                                <th>Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Asset Report</td>
                                <td>{apiData.Active}</td>
                                <td>{apiData.Deactivate}</td>
                                <td>2023</td>
                                <td>{apiData.Active+apiData.Deactivate}</td>
                            </tr>
                            
                            </tbody>
                            </Table>
                    </div>
                    </div>
                    <div className="col-1">
                   
                    </div>
                </div>
            </div>
   
    </div>
   
    
    </>
  )
}

export default KplAssetReport;